<!-- app-form-page [config]="config"></app-form-page -->
<div style="margin:20px" formPageHolder [attr.data-table-ready]="loaded ? 'true' : null">
    <div style="display:flex; align-items:center;">
        <h1 style="flex:1; margin:0">Agent Settings</h1>
        <app-doc-help docPath="omc-professional/agent-settings"></app-doc-help>
    </div>
    <div style="display:flex; flex-flow: row wrap;">
        <div style="width:330px;">
            <mat-card style="padding:20px; margin:10px">
                <app-text-edit label="Name" [textValue]="team.name" (editor)="editName()"></app-text-edit>
                <app-text-edit label="Legal Name" [textValue]="team.legalName" (editor)="editLegalName()"></app-text-edit>
                <app-text-edit label="Business Address" [textValue]="team.defaultAddress" (editor)="editAddress()" [isHtml]="true"></app-text-edit>
                <app-text-edit label="Use Logo" [textValue]="team.useLogo"
                    (editor)="editUseLogo()"
                    (deleter)="deleteParameter('useLogo', team.useLogo)"
                    deleteTip="Remove and revert to default (no)">
                </app-text-edit>
                @if (team.useLogo === 'yes') {
                    <div style="text-align:center; margin: 8px 0;">
                        <img src="https://clgassets.fra1.cdn.digitaloceanspaces.com/logos/{{team.id}}.png"
                            style="height:53px; width:163px; margin-bottom: 20px"
                            alt="Logo not available, please set Use Logo to No to avoid errors">
                    </div>
                }                
            </mat-card>
        </div>
        <div style="width:330px;">
            <mat-card style="padding:20px; margin:10px">
                <h4>Parameters</h4>
                <app-text-edit label="Show OMC Dashboard" [textValue]="team.showOmcDashboard"
                    (editor)="editShowOmcDashboard()"
                    (deleter)="deleteParameter('showOmcDashboard', team.showOmcDashboard)"
                    deleteTip="Remove and revert to default (no)">
                </app-text-edit>                
                <app-text-edit label="AI Level" [textValue]="team.aiLevel"
                    (editor)="editAiLevel()"
                    (deleter)="deleteParameter('aiLevel', team.aiLevel)"
                    deleteTip="Remove and revert to default (none)">
                </app-text-edit>
                <app-text-edit label="Billing Address" [textValue]="team.billingAddress" (editor)="editBillingAddress()"
                    (deleter)="deleteParameter('billingAddress', team.billingAddress)" [isHtml]="true"
                    deleteTip="Remove billing address and restore default value">
                </app-text-edit>
                <app-text-edit label="Payment Terms" [textValue]="team.paymentTerms" (editor)="editPaymentTerms()"
                    (deleter)="deleteParameter('paymentTerms', team.paymentTerms)"
                    deleteTip="Remove payment terms and restore default value">
                </app-text-edit>
                <app-text-edit label="Service Charge Label" [textValue]="team.serviceChargeLabel" (editor)="editServiceChargeLabel()"
                    (deleter)="deleteParameter('serviceChargeLabel', team.serviceChargeLabel)"
                    deleteTip="Remove and restore default value (Invoice Notice)">
                </app-text-edit>
                <app-text-edit label="Credit Note Label" [textValue]="team.creditNoteLabel" (editor)="editCreditNoteLabel()"
                    (deleter)="deleteParameter('creditNoteLabel', team.creditNoteLabel)"
                    deleteTip="Remove and restore default value (Credit Notice)">
                </app-text-edit>

                <app-text-edit label="Sending Email" [textValue]="team.fromEmail"></app-text-edit>
                <app-text-edit label="Reply To Address" [textValue]="team.replyToMail"></app-text-edit>

                <app-text-edit label="Mail Sending Name" [textValue]="team.mailSendingName" (editor)="editMailSendingName()"
                    (deleter)="deleteParameter('mailSendingName', team.mailSendingName)" [highlight]="!!getParameter('mailSendingName')"
                    deleteTip="Remove mail sending name and restore default value">
                </app-text-edit>
                <app-text-edit label="Mail Sending Account" [textValue]="team.mailSendingAccount" (editor)="editMailSendingAccount()"
                    (deleter)="deleteParameter('mailSendingAccount', team.mailSendingAccount)"
                    [highlight]="!!getParameter('mailSendingAccount')" deleteTip="Remove mail sending account and restore default value">
                </app-text-edit>

                <app-text-edit label="Mail Sending Domain" [textValue]="team.mailSendingDomain" (editor)="editMailSendingDomain()"
                    (deleter)="deleteParameter('mailSendingDomain', team.mailSendingDomain)"
                    [highlight]="!!getParameter('mailSendingDomain')"
                    deleteTip="Remove mail sending domain and use default OurOMC sending domain">
                </app-text-edit>
                <app-text-edit label="Mail Reply To Domain" [textValue]="team.mailReplyToDomain" (editor)="editMailReplyToDomain()"
                    (deleter)="deleteParameter('mailReplyToDomain', team.mailReplyToDomain)"
                    [highlight]="!!getParameter('mailReplyToDomain')"
                    deleteTip="Remove mail replyTo domain and use default OurOMC receipt domain">
                </app-text-edit>
            </mat-card>
        </div>
    </div>
</div>
